@file:OptIn(ExperimentalJsExport::class)

package com.dotpx.ambient

/** JS adapter exposes JSON without leaking Kotlin implementation types into host code. */
@JsExport
class WebPurchaseLinkCore(saved: String?, store: (String?) -> Boolean, serverHost: String) {
    private val core = PurchaseLinkDevice("web", "Web browser", serverHost, saved, object : PurchaseLinkStorage {
        override fun write(value: String?): Boolean = store(value)
    })

    fun snapshot(now: Double): String = core.snapshot(now.toLong()).toJson()
    fun create(now: Double) = core.create(now.toLong())
    fun refresh(now: Double) = core.refresh(now.toLong())
    fun unlink(now: Double) = core.unlink(now.toLong())
    fun tick(now: Double) = core.tick(now.toLong())
    fun nextRequest(): String? = core.nextRequest()?.toJson()
    fun complete(id: Double, status: Int, body: String, now: Double) = core.complete(id.toLong(), status, body, now.toLong())
    fun close() = core.close()
}
